export const array_to_sentence = (arr) => {
  if (arr.length === 0) return "";
  if (arr.length === 1) return arr[0];
  if (arr.length === 2) return `${arr[0]} dan ${arr[1]}`;

  const lastElement = arr.pop();
  return `${arr.join(", ")}, dan ${lastElement}`;
}